import { CustomerChatMessageVehicleRecommendationCarouselDataDto } from '@orcar/common';
import { useEffect, useState } from 'react';
import {
  Carousel,
  CarouselApi,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from '@/ui/Carousel';
import { cn } from '@/utils/cn';
import VehicleCard from './VehicleCard';

const VehicleList = ({
  data,
  time,
  isSure,
  onClick,
  isDisabled,
}: {
  data: CustomerChatMessageVehicleRecommendationCarouselDataDto;
  time: string;
  onClick: (vehicleModelName: string) => void;
  isSure?: boolean;
  isDisabled?: boolean;
}) => {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [api, setApi] = useState<CarouselApi>();

  const handleClickThumbnail = (index: number) => {
    api?.scrollTo(index);
    setSelectedIndex(index);
  };

  const onSelect = (api: CarouselApi) => {
    if (!api) return;
    setSelectedIndex(api.selectedScrollSnap());
  };

  useEffect(() => {
    if (!api) return;
    api.on('select', onSelect);
  }, [api]);

  const vehicles = data.items.slice(0, 6);

  return (
    <div className='flex items-end gap-1'>
      <div
        className={cn(
          'bg-mobi-gradient flex w-fit max-w-[1000px] flex-col items-center justify-center overflow-hidden rounded-s bg-primary-020 px-10 py-5',
          isSure && 'w-[calc(100vw-60px)] bg-sure-020 px-10 py-5',
        )}
      >
        {isSure && (
          <>
            <Carousel className='h-full w-[calc(100%)]' setApi={setApi}>
              <CarouselContent className={cn('flex h-full gap-2')}>
                {isSure &&
                  data.items.map((item, index) => (
                    <CarouselItem key={index} className='h-full'>
                      <VehicleCard
                        tag={[{ text: item.vehicleModelType, type: 'solid' }]}
                        title={item.vehicleModelName}
                        imgUrl={item.vehicleImageUrl}
                        price={`$${item.price.toFixed(2)}`}
                        isSure={isSure}
                        onClick={() => onClick(item.vehicleModelName)}
                        isDisabled={isDisabled}
                      />
                    </CarouselItem>
                  ))}
              </CarouselContent>
              <CarouselPrevious className='-left-9' />
              <CarouselNext className='-right-9' />
            </Carousel>
            <div className={cn('flex gap-2 pt-5')}>
              {vehicles.map((item, index) => (
                <div
                  key={index}
                  className={cn(
                    'size-2.5 cursor-pointer rounded-full bg-grey-000',
                    isSure && 'size-2',
                    selectedIndex === index && !isSure && 'bg-primary-050',
                    selectedIndex === index && isSure && 'bg-sure-050',
                  )}
                  onClick={() => handleClickThumbnail(index)}
                />
              ))}
            </div>
          </>
        )}
        {!isSure &&
          (vehicles.length > 4 ? (
            <>
              <Carousel className='h-full w-[calc(100%)]' setApi={setApi}>
                <CarouselContent className={cn('flex h-full gap-2')}>
                  {vehicles.map((item, index) => (
                    <CarouselItem
                      key={index}
                      className={cn('h-full basis-3/12')}
                    >
                      <VehicleCard
                        tag={[{ text: item.vehicleModelType, type: 'solid' }]}
                        title={item.vehicleModelName}
                        imgUrl={item.vehicleImageUrl}
                        price={`$${item.price.toLocaleString()}`}
                        isSure={isSure}
                        onClick={() => onClick(item.vehicleModelName)}
                        isDisabled={isDisabled}
                      />
                    </CarouselItem>
                  ))}
                </CarouselContent>
                <CarouselPrevious className='-left-9' />
                <CarouselNext className='-right-9' />
              </Carousel>
            </>
          ) : (
            <div className='flex gap-2'>
              {vehicles.map((item, index) => (
                <VehicleCard
                  key={index}
                  tag={[{ text: item.vehicleModelType, type: 'solid' }]}
                  title={item.vehicleModelName}
                  imgUrl={item.vehicleImageUrl}
                  price={`$${item.price.toFixed(2)}`}
                  isSure={isSure}
                  onClick={() => onClick(item.vehicleModelName)}
                  isDisabled={isDisabled}
                />
              ))}
            </div>
          ))}
      </div>
      <p className='text-caption2 tracking-l text-grey-050'>{time}</p>
    </div>
  );
};

export default VehicleList;
